<template>
  <div v-if="loading">Loading ...</div>
  <div v-else class="flex">
    <div class="padding-right margin-bottom" style="width: 30%;">
      <div
        class="customer-discount-button"
        v-for="discount in data.discounts"
        v-on:click="if(! discount.discount.closed_at){edit = discount.discount.id;tab=null}"
        v-bind:class="{
					clickable: ! discount.discount.closed_at,
          active: edit == discount.discount.id,
				}"
      >
        <div
          class="icon">
            <SvgIcon
              name="discount"
              />
          </div>
        <div>

          <template v-if="discount.discount.type == 'free_styling'">Free styling</template>
          <template v-if="discount.discount.type == 'percentage'">{{ discount.discount.value }}%</template>
          <template
            v-if="discount.discount.type == 'fixed'"
          >{{ data.customer.locale.currency }} {{ discount.discount.value }}</template>

          <!-- Event -->
          <template v-if="discount.trigger">
            <template v-if="discount.trigger.event == 'create_order'"> on next order</template>
          </template>

          <div v-if="discount.discount.closed_at" class="note">Discount disabled</div>

          <div
            class="note xs-margin-top">
            <span
              v-if="discount.applied">
              Applied to {{ discount.applied_on.order_id }} on
              <Format
                style="display: inline-block;"
                type="date"
                :value="discount.applied_on.created_at"
                />
              </span>
              <span v-else-if="discount.trigger ? discount.trigger.expired : false">
                Expired
              </span>
              <span v-else>Pending</span>
          </div>
        </div>

      </div>

      <div
        v-on:click="tab = 'history';edit=null"
        class="customer-discount-button"
        v-bind:class="{
          active: tab === 'history',
        }">
        <div
          class="icon">
          <SvgIcon
              name="history"
              />
        </div>
        <div>
          History
        </div>
      </div>

      <div
        v-on:click="create"
        class="customer-discount-button"
        v-bind:class="{
          loading: saving,
        }">
        <div
          class="icon">
          <SvgIcon
              name="add"
              />
        </div>
        <div>
          Create discount for upcoming order
        </div>
      </div>

      <div
        v-on:click="addPrechurnDiscount"
        class="customer-discount-button"
        v-bind:class="{
          loading: saving,
        }">
        <div
          class="icon">
          <SvgIcon
              name="customer"
              />
        </div>
        <div>
          Add free styling + 200DKK/25EUR
        </div>
      </div>

    </div>

    <div
      class="margin-left flex-grow"
      v-if="tab == 'history'">
        <h2 class="margin-right no-margin-top no-margin-bottom">History</h2>

        <table
          style="width: 100%"
          class="basic">
          <thead>
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Offer</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="record in data.history">
              <td>
                <Format
                  type="date"
                  :time="true"
                  :value="record.date"
                  />
              </td>
              <td>{{ getText(record) }}</td>
              <td>{{ getDiscountText(record.discount) }}</td>
            </tr>
          </tbody>
        </table>
        <button class="large-margin-top" v-on:click="load">s</button>
    </div>

    <div class="margin-left" v-if="edit">
      <div class="large-margin-bottom flex flex-vertical-center">
        <h2 class="margin-right no-margin-top no-margin-bottom">Edit discount {{ edit }}</h2>
        <!-- <div> -->
        <button v-on:click="edit = false;" class="gray small">Close</button>
        <!-- </div> -->
      </div>
      <DiscountEditor :id="edit" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import DiscountEditor from '@/components/DiscountEditor.vue'

export default {
  props: ['id'],
  components: {
    DiscountEditor
  },
  data: () => ({
    loading: false,
    saving: false,
    data: {},
    tab: null,
    edit: false
  }),
  methods: {
    getDiscountText (discount) {
      switch (discount.type) {
        case 'percentage':
          return '{value}%'.replace('{value}', discount.value)
        case 'fixed':
          return '{value}'.replace('{value}', discount.value)
        case 'free_styling':
          return 'Free styling'
        default:
          return record
      }
    },
    getText (record) {
      switch (record.type) {
        case 'attached':
          return 'Discount #{id} attached to customer'.replace('{id}', record.discount.id)
        case 'applied':
          return 'Applied #{id} on order {order}'
            .replace('{id}', record.discount.id)
            .replace('{order}', record.applied_on.order_id)
        default:
          return record
      }
    },
    load () {
      Vue.$api.get(
        '/customer/' + this.id + '/discount-schedule',
        {},
        {
          loader: toggle => (this.loading = toggle),
          callback: data => (this.data = data)
        }
      )
    },
    create () {
      if (this.saving) {
        return
      }

      Vue.$api.post(
        '/customer/' + this.id + '/discount-schedule',
        {},
        {
          loader: toggle => (this.saving = toggle),
          callback: data => this.load()
        }
      )
    },
    addPrechurnDiscount () {
      if (this.saving) {
        return
      }
      Vue.$api.post(
        '/customer/' + this.id + '/discount/prechurn',
        {},
        {
          loader: toggle => (this.saving = toggle),
          callback: data => this.load()
        }
      )
    }
  },
  created () {
    this.load()
  }
}
</script>

<style lang="less">
  .customer-discount-button {
    display: flex;
    align-items: center;
    background: #fff;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    padding-top: 15px;
    padding-bottom: 15px;
    transition: 200ms;
    &.active {
      background: #ffffcf;
      padding-left: 15px;
    }
    &.loading {
      cursor: not-allowed;
    }
    .icon {
      margin-right: 15px;
    }
    .svg-icon, .svg-icon svg {
      width: 24px !important;
      height: 24px !important;
    }
  }
</style>
